// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1JrPa","errorLogs":"styles_errorLogs__1jCYp"};